import Vue from 'vue'
// 引入自己的语言包
import chinese from "./zn"; // 中文
import english from "./en"; // 英文
import {getBrowserLang} from "../utils/checkLang";

// element ui 国际化
import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import znLocale from 'element-ui/lib/locale/lang/zh-CN'
// 国际化
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 配置i18n语言包
const messages = {
  en: {
    ...english,
    ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zn: {
    ...chinese,
    ...znLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}

// 国际化配置
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || getBrowserLang(), // 默认中文
  messages,
  silentTranslationWarn: true,
})

// vue配置
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js